export default __webpack_public_path__ + "static/media/logo.ae86df8a.jpg";